import axios from 'axios';

/**
 * Normalises an unknown thrown value into a user-facing message.
 * The API returns `{ error, statusCode }` from ExceptionHandlingMiddleware and
 * `{ message }` from the ApiResponse envelope.
 */
export function extractErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as
      | { error?: string; message?: string; title?: string }
      | undefined;
    return data?.error ?? data?.message ?? data?.title ?? error.message ?? fallback;
  }

  if (error instanceof Error && error.message) return error.message;

  return fallback;
}
